import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { BreadcrumbModel } from '../../model/common/breadcrumb.model';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  constructor(private router: Router) {}

  generateBreadcrumbs(route: ActivatedRouteSnapshot): { label: string; url: string }[] {
    let breadcrumbs: { label: string; url: string }[] = [];
    let currentRoute = route;
    let url = '';

    while (currentRoute) {
      if (currentRoute.data['breadcrumb']) {
        url += `/${currentRoute.url.map(segment => segment.path).join('/')}`;
        breadcrumbs.push({ label: currentRoute.data['breadcrumb'], url });
      }
      currentRoute = currentRoute.parent!;
    }
    return breadcrumbs;
  }
}
